<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div id="colleges" class="col-12 col-md-6">
            <h4 class="text-center">
              Collèges
              <button
                data-toggle="modal"
                data-target="#ajouter"
                @click="create($event, 'college')"
                class="btn btn-info btn-link btn-just-icon"
                rel="tooltip"
                data-placement="right"
                data-original-title="ajouter un collège"
              >
                <i class="material-icons">add_circle</i>
              </button>
            </h4>
            <div class="table-container">
              <table v-if="collegesLoaded" class="table">
                <tbody>
                  <tr
                    v-for="college in colleges"
                    :key="`college_${college.id}`"
                  >
                    <td>{{ college.nom }}</td>
                    <td class="td-actions text-right">
                      <button
                        :data-id="college.id"
                        data-toggle="modal"
                        @click="update($event, 'college')"
                        data-target="#modifier"
                        class="btn btn-info btn-link btn-sm edit"
                      >
                        <i class="material-icons">edit</i>
                      </button>
                      <button
                        :data-id="college.id"
                        data-toggle="modal"
                        data-target="#supprimer"
                        class="btn btn-danger btn-link btn-sm delete"
                      >
                        <i class="material-icons">delete</i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="!colleges.length">
                    <td class="text-center">Aucun collège trouvé.</td>
                  </tr>
                </tbody>
              </table>
              <vcl-table v-else :rows="4" :columns="2"></vcl-table>
            </div>
          </div>
          <div id="etablissements" class="col-12 col-md-6">
            <h4 class="text-center">
              Etablissements
              <button
                id="synchroniser"
                class="btn btn-info btn-link btn-just-icon"
                rel="tooltip"
                data-placement="bottom"
                data-original-title="synchroniser les etablissements"
              >
                <i class="material-icons">autorenew</i>
              </button>
              <button
                data-toggle="modal"
                data-target="#ajouter"
                @click="create($event, 'etablissement')"
                class="btn btn-info btn-link btn-just-icon"
                rel="tooltip"
                data-placement="bottom"
                data-original-title="ajouter un etablissement"
              >
                <i class="material-icons">add_circle</i>
              </button>
            </h4>
            <div class="table-container">
              <table v-if="etablissementsLoaded" class="table">
                <tbody>
                  <tr
                    v-for="etablissement in etablissements"
                    :key="`etab_${etablissement.id}`"
                  >
                    <td width="80%">{{ etablissement.nom }}</td>
                    <td class="td-actions text-right">
                      <button
                        :data-id="etablissement.id"
                        data-toggle="modal"
                        @click="update($event, 'etablissement')"
                        data-target="#modifier"
                        class="btn btn-info btn-link btn-sm edit"
                      >
                        <i class="material-icons">edit</i>
                      </button>
                      <button
                        :data-id="etablissement.id"
                        data-toggle="modal"
                        data-target="#supprimer"
                        class="btn btn-danger btn-link btn-sm delete"
                      >
                        <i class="material-icons">delete</i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="!etablissements.length">
                    <td class="text-center">Aucun collège trouvé.</td>
                  </tr>
                </tbody>
              </table>
              <vcl-table v-else :rows="4" :columns="2"></vcl-table>
            </div>
          </div>
        </div>
        <div class="row">
          <div id="matieres" class="col-12 col-md-6">
            <h4 class="text-center">
              Matières
              <button
                data-toggle="modal"
                data-target="#ajouter"
                @click="create($event, 'matiere')"
                class="btn btn-info btn-link btn-just-icon"
                rel="tooltip"
                data-placement="right"
                data-original-title="ajouter une matière"
              >
                <i class="material-icons">add_circle</i>
              </button>
            </h4>
            <div class="table-container">
              <table v-if="matieresLoaded" class="table">
                <tbody>
                  <tr
                    v-for="matiere in matieres"
                    :key="`matiere_${matiere.id}`"
                  >
                    <td width="80%">{{ matiere.nom }}</td>
                    <td class="td-actions text-right">
                      <button
                        :data-id="matiere.id"
                        data-toggle="modal"
                        @click="update($event, 'college')"
                        data-target="#modifier"
                        class="btn btn-info btn-link btn-sm edit"
                      >
                        <i class="material-icons">edit</i>
                      </button>
                      <button
                        :data-id="matiere.id"
                        data-toggle="modal"
                        data-target="#supprimer"
                        class="btn btn-danger btn-link btn-sm delete"
                      >
                        <i class="material-icons">delete</i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="!matieres.length">
                    <td class="text-center">Aucune matière trouvée.</td>
                  </tr>
                </tbody>
              </table>
              <vcl-table v-else :rows="4" :columns="2"></vcl-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal modal-mini modal-primary" role="dialog" id="ajouter">
      <div class="modal-dialog modal-small">
        <div class="modal-content">
          <form action="" method="post">
            <input type="hidden" name="_token" value="" v-model="csrf_token" />
            <div class="modal-header">
              <h5 class="modal-title">Ajouter un collège</h5>
            </div>
            <div class="modal-body">
              <div class="form-group bmd-form-group">
                <label for="" class="bmd-label-floating">Nom</label>
                <input type="text" name="nom" class="form-control" />
              </div>
              <div v-show="element == 'etablissement'">
                <select
                  name="college_id"
                  class="selectpicker w-100"
                  data-style="select-with-transition"
                  title="College"
                >
                  <option
                    v-for="college in colleges"
                    :key="`s_college_${college.id}`"
                    :value="college.id"
                  >
                    {{ college.nom }}
                  </option>
                </select>
              </div>
              <div v-show="element == 'matiere'">
                <select
                  name="niveau"
                  class="selectpicker w-100"
                  data-style="select-with-transition"
                  title="Niveau"
                >
                  <option value="1A">1A</option>
                  <option value="2A">2A</option>
                  <option value="3A">3A</option>
                  <option value="4A">4A</option>
                  <option value="5A">5A</option>
                  <option value="6A">6A</option>
                </select>
              </div>
            </div>
            <div class="modal-footer mt-3 d-flex justify-space-between">
              <button data-dismiss="modal" class="btn btn-outline-danger">
                Annuler
              </button>
              <button type="submit" class="btn btn-info">Ajouter</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal modal-mini modal-primary" role="dialog" id="modifier">
      <div class="modal-dialog modal-small">
        <div class="modal-content">
          <form action="" method="post">
            <input type="hidden" name="_token" value="" v-model="csrf_token" />
            <input type="hidden" name="_method" value="PUT" />
            <div class="modal-header">
              <h5 class="modal-title">Modifier le collège</h5>
            </div>
            <div class="modal-body">
              <div class="form-group bmd-form-group">
                <label for="" class="bmd-label-floating">Nom</label>
                <input type="text" name="nom" class="form-control" />
              </div>
              <div v-show="element == 'etablissement'">
                <select
                  name="college_id"
                  class="selectpicker w-100"
                  data-style="select-with-transition"
                  title="College"
                >
                  <option
                    v-for="college in colleges"
                    :key="`s_college_${college.id}`"
                    :value="college.id"
                  >
                    {{ college.nom }}
                  </option>
                </select>
              </div>
              <div v-show="element == 'matiere'">
                <select
                  name="niveau"
                  class="selectpicker w-100"
                  data-style="select-with-transition"
                  title="Niveau"
                >
                  <option value="1A">1A</option>
                  <option value="2A">2A</option>
                  <option value="3A">3A</option>
                  <option value="4A">4A</option>
                  <option value="5A">5A</option>
                  <option value="6A">6A</option>
                </select>
              </div>
            </div>
            <div class="modal-footer mt-3 d-flex justify-space-between">
              <button data-dismiss="modal" class="btn btn-outline-danger">
                Annuler
              </button>
              <button type="submit" class="btn btn-info">Modifier</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal modal-mini" role="dialog" id="supprimer">
      <div class="modal-dialog modal-small">
        <div class="modal-content">
          <form action="" method="post">
            <input type="hidden" name="_token" value="" v-model="csrf_token" />
            <input type="hidden" name="_method" value="DELETE" />
            <div class="modal-header">
              <h5 class="modal-title"></h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h4 class="text-danger">Attention !</h4>
              <p>Vous êtes sûr de supprimer ce collège ?</p>
            </div>
            <div class="modal-footer mt-3 d-flex justify-space-between">
              <button data-dismiss="modal" class="btn btn-success">
                Annuler
              </button>
              <button type="submit" class="btn btn-outline-danger">
                Supprimer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VclTable } from "vue-content-loading";
export default {
  props: {
    api_token: String,
  },
  components: {
    VclTable,
  },
  data() {
    return {
      csrf_token: null,
      colleges: [],
      etablissements: [],
      matieres: [],
      collegesLoaded: 0,
      etablissementsLoaded: 0,
      matieresLoaded: 0,
      element: null,
      config: {
        headers: {
          Authorization: "Bearer " + this.api_token,
        },
      },
    };
  },
  methods: {
    create(event, el) {
      switch (el) {
        case "etablissement":
          this.element = "etablissement";
          $("#ajouter form").attr("action", "etablissement");
          $("#ajouter .modal-title").text("Ajouter un etablissement");
          break;
        case "college":
          this.element = null;
          $("#ajouter form").attr("action", "college");
          $("#ajouter .modal-title").text("Ajouter un collège");
          break;
        case "matiere":
          this.element = "matiere";
          $("#ajouter form").attr("action", "matiere");
          $("#ajouter .modal-title").text("Ajouter une matière");
        default:
          break;
      }
    },
    update(event, el) {
      switch (el) {
        case "etablissement":
          this.element = "etablissement";
          $("#modifier form").attr("action", "etablissement");
          $("#modifier .modal-title").text("Modifier un etablissement");
          break;
        case "college":
          this.element = null;
          $("#modifier form").attr("action", "college");
          $("#modifier .modal-title").text("Modifier un collège");
          break;
        case "matiere":
          this.element = "matiere";
          $("#modifier form").attr("action", "matiere");
          $("#modifier .modal-title").text("Modifier une matière");
        default:
          break;
      }
    },
  },
  beforeMount() {
    this.csrf_token = $('meta[name="csrf-token"]').attr("content");
    axios.get("/api/colleges", this.config).then((res) => {
      this.colleges = res.data;
      this.collegesLoaded = 1;
    });

    axios.get("/api/etablissements", this.config).then((res) => {
      this.etablissements = res.data;
      this.etablissementsLoaded = 1;
    });

    axios.get("/api/matieres", this.config).then((res) => {
      this.matieres = res.data;
      this.matieresLoaded = 1;
    });
  },
};
</script>